module.exports = __webpack_public_path__ + "img/vertical_4_3_8004.efabf50a.png";